module.exports = __webpack_public_path__ + "static/ebook_mobile_modal-5ac2a8dcdc05f3a5d3f35e76e36b52c2.jpg";